import { render, staticRenderFns } from "./InvestmentOrders.vue?vue&type=template&id=6a48a805"
import script from "./InvestmentOrders.vue?vue&type=script&lang=js"
export * from "./InvestmentOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports